import { render, staticRenderFns } from "./emailAttachmentsDialog.vue?vue&type=template&id=30ed47f3&lang=pug"
import script from "./emailAttachmentsDialog.vue?vue&type=script&lang=js"
export * from "./emailAttachmentsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports